import { Command } from 'commander'
import as from 'ansis'
import fs from 'node:fs'

import { loadOpenApiFile } from '@/domains/document/helpers'
import { output } from '@/helpers/std-out'

export function BundleCommand() {
  const cmd = new Command('bundle')

  cmd.description('Resolve all references in an OpenAPI file')
  cmd.argument('[file]', 'file to bundle')
  cmd.option('-o, --output <file>', 'output file')
  cmd.action(async (fileArgument: string, { output: outputFilePath }) => {
    const startTime = performance.now()

    if (!fileArgument) {
      return output
        .error()
        .title('Invalid argument')
        .message('Please provide a file path')
        .exit('error')
    }

    const { specification: newContent } = await loadOpenApiFile(fileArgument)

    // Replace file content with newContent
    const cache: any[] = []
    const json = JSON.stringify(
      newContent,
      (_, value) => {
        if (typeof value === 'object' && value !== null) {
          if (cache.indexOf(value) !== -1) {
            // Circular reference found, discard key
            return
          }

          // Store value in our collection
          cache.push(value)
        }
        return value
      },
      2,
    )

    fs.writeFileSync(outputFilePath ?? fileArgument, json, 'utf8')

    const endTime = performance.now()

    output
      .info()
      .line(
        `${as.green('OpenAPI Schema bundled')} in ${as.white(`${as.bold(`${Math.round(endTime - startTime)}`)} ms`)}`,
      )
      .print()
  })

  return cmd
}
